const ssoMeActionTypes = {
  RESET_STATE: 'RESET_STATE',
  SET_DATA: 'SET_DATA',
};

export { ssoMeActionTypes as default };
